import {FlashOutline} from "react-ionicons";

export default function LightningIcon() {
  return (
    <FlashOutline color="var(--cyan)" />
  )
}
